import gql from 'graphql-tag';

const SignInMutation = gql`
  mutation SignIn(
    $email: String!
    $password: String!
    $shop: String!
    $subdomain: String!
  ) {
    signIn(
      input: {
        email: $email
        password: $password
        shop: $shop
        subdomain: $subdomain
      }
    ) {
      session {
        id
        email
        tenant {
          isShopifyLead
          name
          onboardingChecklist {
            showOnboardingModal
          }
          siteBuilderThemeId
          sitePlan
          subdomain
        }
      }
      result {
        success
        status
        errors {
          code
          title
          message
        }
      }
    }
  }
`;

export default SignInMutation;
